import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import config from './sublane-config';
Swiper.use([Navigation]);

export default function initSubLanes() {
    return new Swiper('.tx-mediathek-sublane .swiper', config);
}

document.addEventListener("DOMContentLoaded", (event) => {
    window.SK = window.SK || {};
    window.SK.sublanes = initSubLanes();
    console.log('🌞️ Sublane(s) initialized');
})